import { action } from 'satcheljs';
// TODO VSO 32525: move this out of attachment well.
export var refreshSharingTipsAttachmentWell = action('REFRESH_SHARING_TIPS_ATTACHMENT_WELL', function (attachmentWellViewState, parentItemId, hasExternalRecipients, infoBarAddHandler, infoBarRemoveHandler) { return ({
    attachmentWellViewState: attachmentWellViewState,
    parentItemId: parentItemId,
    hasExternalRecipients: hasExternalRecipients,
    infoBarAddHandler: infoBarAddHandler,
    infoBarRemoveHandler: infoBarRemoveHandler,
}); });
export var removeLinksThenRefreshSharingTips = action('REMOVE_LINKS_THEN_REFRESH_SHARING_TIPS', function (linkIds) { return ({
    linkIds: linkIds,
}); });
//# sourceMappingURL=publicActions.js.map